import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { learnings } from "../mock/mock";
import { Reveal, EASE } from "../components/Reveal";

const Row = ({ item }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-t" style={{ borderColor: "var(--hair-soft)" }}>
      <button
        onClick={() => setOpen((o) => !o)}
        className="w-full text-left group py-9 md:py-11"
        data-testid={`learning-row-${item.n}`}
      >
        <div className="flex items-start gap-6 md:gap-12">
          <span
            className={`hidden md:block flex-shrink-0 w-20 font-display text-[40px] md:text-[52px] leading-[0.9] transition-colors duration-500 ${
              open ? "text-terra" : "t-faint"
            }`}
          >
            {item.n}
          </span>
          <div className="flex-1">
            <h3 className="font-display font-bold text-[19px] md:text-[25px] leading-[1.25] t-fg tracking-[-0.02em] max-w-[34ch]">
              <span className="md:hidden t-faint mr-3">{item.n}</span>
              {item.front}
            </h3>
            <AnimatePresence initial={false}>
              {open && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.6, ease: EASE }}
                  className="overflow-hidden"
                >
                  <p className="text-[15px] md:text-[17px] leading-[1.8] t-dim pt-6 max-w-[64ch]">
                    {item.back}
                  </p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
          <motion.div
            animate={{ rotate: open ? 45 : 0 }}
            transition={{ duration: 0.5, ease: EASE }}
            className={`mt-1.5 flex-shrink-0 transition-colors duration-300 ${
              open ? "text-terra" : "t-dim group-hover:t-fg"
            }`}
          >
            <Plus size={20} strokeWidth={1.4} />
          </motion.div>
        </div>
      </button>
    </div>
  );
};

const Learned = () => (
  <section id="learned" data-theme="light" className="sec-light relative px-6 md:px-12 py-28 md:py-40" data-testid="learned-section">
    <div className="max-w-[1240px] mx-auto">
      <Reveal>
        <div className="eyebrow">02 · What I've Learned</div>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-display font-extrabold text-[32px] md:text-[52px] leading-[1.02] t-fg tracking-[-0.035em] mt-8 mb-16 md:mb-24 max-w-[20ch]">
          Ten convictions, repeatedly tested<span className="t-terra">.</span>
        </h2>
      </Reveal>
      <div className="border-b" style={{ borderColor: "var(--hair-soft)" }}>
        {learnings.map((item, i) => (
          <Reveal key={item.n} delay={Math.min(i * 0.04, 0.2)} y={18}>
            <Row item={item} />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Learned;
